import _ from 'lodash';
import coreAuth from './coreAuth';

let timeout = null;
let cancellationPending = false;
let lastActiveDate = null;
let handleSessionExpirationCallback = null;

/*
TIMEOUT_MS is set in milliseconds.
TIMEOUT_MS should be set to the following:
TIMEOUT_MS = config.session_timeout - 30 seconds
e.g., if config.session_timeout == 3600, TIMEOUT_MS should be = 3,570,000
*/
const TIMEOUT_MS = 3570000;
const SESSION_EXPIRING_WINDOW = 60000;
const CHECK_INTERVAL = 1000;

export function setHandleSessionExpirationCallback(callback) {
  handleSessionExpirationCallback = callback;
}

export function checkIfSessionExpired() {
  const ms = new Date() - lastActiveDate;
  if (ms >= TIMEOUT_MS - SESSION_EXPIRING_WINDOW) {
    handleSessionExpirationCallback();
    clearInterval(timeout);
  }
}

export function resetSessionExpirationTimeout() {
  if (!coreAuth.user.id) return null;
  cancellationPending = true;

  clearInterval(timeout);
  setSessionExpirationTimeout();
}

export function setSessionExpirationTimeout() {
  if (_.startsWith(window.location.pathname, '/user_session')) return;
  if (!coreAuth.user.id) return null;

  lastActiveDate = new Date();
  timeout = setInterval(checkIfSessionExpired, CHECK_INTERVAL);
}

export function cancelLoginPending() {
  return cancellationPending;
}

export function onLoginShown() {
  cancellationPending = false;
}

export function getExpiryDate() {
  return new Date(lastActiveDate.getTime() + TIMEOUT_MS);
}
